import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";

const transactionHistoryFilterList = (permissions) => {
  const defaultFilter = [
    // <AutocompleteInput
    //   optionText="name"
    //   source="code"
    //   variant="outlined"
    //   choices={[
    //     { id: "OP", name: "OP" },
    //     { id: "MPO", name: "MPO" },
    //     { id: "PJ", name: "PJ" },
    //     { id: "RT", name: "RT" },
    //     { id: "RB", name: "RB" },
    //     { id: "SO", name: "SO" },
    //     { id: "SJ", name: "SJ" },
    //     { id: "RJ", name: "RJ" },
    //     { id: "APP", name: "APP" },
    //     { id: "KH", name: "KH" },
    //     { id: "ARP", name: "ARP" },
    //     { id: "KP", name: "KP" },
    //     { id: "CAS", name: "CAS" },
    //     { id: "AJP", name: "AJP" },
    //     { id: "BD", name: "BD" },
    //     { id: "BDP", name: "BDP" },
    //     { id: "BDK", name: "BDK" },
    //     { id: "CBD", name: "CBD" },
    //     { id: "RK", name: "RK" },
    //     { id: "M", name: "M" },
    //   ]}
    // />,
    <TextInput
      alwaysOn
      source="transaction_code"
      label="mine.label.transaction_code"
      resettable
      variant="outlined"
    />,
    <ReferenceInput
      label="mine.label.user"
      source="user_id"
      reference="users"
      alwaysOn
    >
      <AutocompleteInput optionText="username" variant="outlined" />
    </ReferenceInput>,
    <TextInput
      alwaysOn
      source="note"
      label="mine.label.note"
      resettable
      variant="outlined"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default transactionHistoryFilterList;
